// 检测返回值
export function checkRes(json) {
  return new Promise((resolve, reject) => {
    if (json.SZ_HEAD.RESP_CODE === 'S0000') {
      // 请求成功
      resolve({
        data: json.SZ_BODY
      })
    } else {
      reject({
        data: '',
        error: json.SZ_HEAD.RESP_CODE,
        msg: json.SZ_HEAD.RESP_MSG
      })
    }
  })
}

// 获取cookie、
export function getCookie(name) {
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  var arr = document.cookie.match(reg)
  if (arr) {
    return (arr[2])
  } else {
    return null
  }
}

// 设置cookie,增加到vue实例方便全局调用
export function setCookie(cName, value, expiredays) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = cName + '=' + escape(value) + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
};

// 删除cookie
export function delCookie(name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  }
};

// 判断是否为微信
export function isWeixin() {
  let ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == "micromessenger" && ua.match(/WxWork/i) != "wxwork") {
    return true
  }
  return false
};

// 微信内判断是ios设备还是安卓设备
export function isIos () {
  let u = navigator.userAgent
  // let app = navigator.appVersion
  // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 //android端
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端 
  if (isIOS) { 
    console.log('ios')
    return true
  }
  console.log('android')
  return false
};
// 判断是否为企业微信
export function isWxWork() {
  let ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == "micromessenger" && ua.match(/WxWork/i) == "wxwork") { // 企业微信
    return true
  }
  return false
};

// 判断是否为APP
export function isMyApp() {
  if (window.location.href.indexOf('h5.app') >= 0) {
    return true
  }
  return false
};

// 埋点
export function statisticsPing(actionId, options = {}) {
  if (typeof actionId !== 'undefined') {
    var _navigator = window.navigator
    var obj = {
      userAgent: _navigator.userAgent,
      platform: _navigator.platform,
      appCodeName: _navigator.appCodeName,
      appName: _navigator.appName,
      appVersion: _navigator.appVersion
    }

    options = Object.assign({
      mainId: '', // 订单号
      sourceCode: '',
      logContent: JSON.stringify(obj), // 自定义json字符串
      logtype: '',
      // sourceapp: "SZ-ES-SAAS-SERVER",
      sourceapp: 'WAP-SZ-M-WEB',
      openID: '',
      actionid: actionId,
      traceid: '',
      url: window.location.href.replace(/&/g, '_') || '',
      refer: document.referrer.replace(/&/g, '_') || ''
    }, options)

    var img = new Image()
    var _arr = []
    for (var key in options) {
      _arr.push(key + '=' + options[key])
    }
    var _src = _arr.join('&')
    img.src = location.origin + '/ping.php?' + _src + '&_=' + Math.random()
    img = null
  }
}

// toast弹层
// toast弹层
export function toast(msg) {
  if (typeof msg === 'undefined') {
    return
  }
  var tpl = `
    <div style="position:fixed;top:50%;left:50%;max-width: 400px;z-index: 10000;text-align: center;background-color: rgba(0,0,0,.6);padding:10px;color:#fff;border-radius:5px;transform:translate(-50%,-50%)">
      ${msg}
    </div>
  `
  let oBody = document.querySelector('body')
  let lastNode = document.getElementById('sz-toast__pc')
  let currentNode = document.createElement('div')
  currentNode.id = 'sz-toast__pc'
  if (lastNode) {
    oBody.removeChild(lastNode)
  }

  currentNode.innerHTML = tpl

  // 将节点添加到Body中
  oBody.appendChild(currentNode)

  // 三秒后移除
  setTimeout(() => {
    oBody.removeChild(currentNode)
  }, 3000)
}

/**
 * 检测是否为移动端
 */
export function isMobile() {
  // if (/http(s?):\/\/m/.test(location.origin)) {
  //   // 正常判断方法
  //   return true
  // } else if (location.href.indexOf('localhost') > -1 && location.href.indexOf('wap') > -1) {
  //   // 兼容开发环境
  //   return true
  // } else if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
  //   return true
  // }
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

export function compress(img) {
  let canvas = document.createElement("canvas");
  let ctx = canvas.getContext('2d');
  //瓦片canvas
  let tCanvas = document.createElement("canvas");
  let tctx = tCanvas.getContext("2d");
  let initSize = img.src.length;
  let width = img.width;
  let height = img.height;
  //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
  let ratio;
  if ((ratio = width * height / 4000000) > 1) {
    console.log("大于400万像素")
    ratio = Math.sqrt(ratio);
    width /= ratio;
    height /= ratio;
  } else {
    ratio = 1;
  }
  canvas.width = width;
  canvas.height = height;
  //        铺底色
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  //如果图片像素大于100万则使用瓦片绘制
  let count;
  if ((count = width * height / 1000000) > 1) {
    console.log("超过100W像素");
    count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
    //            计算每块瓦片的宽和高
    let nw = ~~(width / count);
    let nh = ~~(height / count);
    tCanvas.width = nw;
    tCanvas.height = nh;
    for (let i = 0; i < count; i++) {
      for (let j = 0; j < count; j++) {
        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
      }
    }
  } else {
    ctx.drawImage(img, 0, 0, width, height);
  }
  //进行最小压缩
  let ndata = canvas.toDataURL('image/jpeg', 0.1);
  console.log('压缩前：' + initSize);
  console.log('压缩后：' + ndata.length);
  console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");
  tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
  return ndata;
}


const cacheScript = {}
// 加载脚本
export function loadScript(url) {
  // 如果已经加载过相同脚本，则不再加载
  if (cacheScript[encodeURIComponent(url)]) return cacheScript[encodeURIComponent(url)]

  // 新加载脚本缓存中记录
  cacheScript[encodeURIComponent(url)] = new Promise((resolve, reject) => {
    const oDom = document.createElement('script')
    oDom.onload = function () {
      resolve()
    }

    oDom.onerror = function () {
      reject(new Error())
    }
    oDom.src = url

    const oHead = document.querySelector('head')
    if (oHead) {
      oHead.appendChild(oDom)
    }
  })

  return cacheScript[encodeURIComponent(url)]
}

function isIos14AndMore(){
  try{
    var str= navigator.userAgent.toLowerCase(); var ver=str.match(/cpu iphone os (.*?) like mac os/); if(!ver){ return false }else{ return ver[1].split("_")[0] >= 14 }
  }catch(e){
    return false;
  }
}

let firstUrl = window.location.href.split('#')[0]

// IOS14及以上由于兼容性问题，就算是 location.href 之后也仍然要用最初的 URL
if (isIos14AndMore()) {
  firstUrl = sessionStorage.getItem('_firstUrl') || firstUrl
  sessionStorage.setItem('_firstUrl', firstUrl)
}

// 设置微信SDK
export function setWXSDK(vm) {
  const apiList = [
    'updateAppMessageShareData',
    'updateTimelineShareData',
    'onMenuShareTimeline', // （即将废弃）
    'onMenuShareAppMessage', // （即将废弃）
    'onMenuShareQQ', // （即将废弃）
    'onMenuShareWeibo',
    'onMenuShareQZone',
    'startRecord',
    'stopRecord',
    'onVoiceRecordEnd',
    'playVoice',
    'pauseVoice',
    'stopVoice',
    'onVoicePlayEnd',
    'uploadVoice',
    'downloadVoice',
    'chooseImage',
    'previewImage',
    'uploadImage',
    'downloadImage',
    'translateVoice',
    'getNetworkType',
    'openLocation',
    'getLocation',
    'hideOptionMenu',
    'showOptionMenu',
    'hideMenuItems',
    'showMenuItems',
    'hideAllNonBaseMenuItem',
    'showAllNonBaseMenuItem',
    'closeWindow',
    'scanQRCode',
    'chooseWXPay',
    'openProductSpecificView',
    'addCard',
    'chooseCard',
    'openCard'
  ]
  return new Promise((resolve, reject) => {
    loadScript('https://res.wx.qq.com/open/js/jweixin-1.6.0.js').finally(() => {
      console.error('load jweixin-1.6.0.js 成功')
      if (!isIos()) {
        firstUrl = window.location.href.split('#')[0]
      }

      vm.$api.post('/es/hms/weChatConfig', { url: firstUrl }).then(res => {
        if (res.data.SZ_HEAD.RESP_CODE === 'S0000') {
          const { appId, timestamp, noncestr, signature } = res.data.SZ_BODY

          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId, // 必填，公众号的唯一标识
            timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature, // 必填，签名，见附录1
            jsApiList: apiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
          console.log('获取配置2')
          wx.ready(() => {
            console.log('微信SDKready')
            resolve()
          })
          wx.error((errInfo) => {
            console.log('微信接口注册失败', errInfo)
            reject(errInfo)
          })
          console.log('获取配置3')
        }
      }).catch((err) => {
        console.log('获取配置出错', err.toString())
        reject(new Error('获取配置出错'))
      })
    })
  })
}
